<template>
  <page-header />
  <a-card title="订单管理">
    <!-- 查询条件 -->
    <a-form layout="inline" :model="searchParams" @finish="handleSearch">
      <a-form-item label="订单号">
        <a-input
            v-model:value="searchParams.order_no"
            placeholder="请输入订单号"
        />
      </a-form-item>
      <a-form-item label="开始时间">
        <a-date-picker
            v-model:value="searchParams.start_time"
            placeholder="请选择开始时间"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            show-time
        />
      </a-form-item>
      <a-form-item label="结束时间">
        <a-date-picker
            v-model:value="searchParams.end_time"
            placeholder="请选择结束时间"
            valueFormat="YYYY-MM-DD HH:mm:ss"
            show-time
        />
      </a-form-item>
      <a-form-item>
        <a-button type="primary" html-type="submit">查询</a-button>
      </a-form-item>
    </a-form>

    <!-- 订单列表 -->
    <a-table
        :dataSource="dataSource"
        :columns="columns"
        :pagination="pagination"
        @change="handleTableChange"
        size="small"
        bordered
        style="margin-top: 20px"
    >
      <template #bodyCell="{ column, record }">
        <!-- 状态列 -->
        <template v-if="column.dataIndex === 'state'">
          {{ stateTitle[record.state] }}
        </template>
        <!-- 操作列 -->
        <template v-if="column.dataIndex === 'action'">
          <a-button type="link" @click="handleView(record)">查看</a-button>
        </template>
      </template>
    </a-table>
  </a-card>
</template>

<script>
import {defineComponent, onMounted, ref} from 'vue'
import {message} from 'ant-design-vue'
import request from '@/utils/request'
import {useRouter} from 'vue-router'
import PageHeader from "@/components/header.vue";

export default defineComponent({
  name: 'OrderPage',
  components: {PageHeader},
  setup() {
    const router = useRouter()
    // 数据源
    const dataSource = ref([])
    const pagination = ref({
      current: 1,
      pageSize: 10,
      total: 0,
      showSizeChanger: true
    })
    const stateTitle = ref({
      created: '未支付',
      paid: '已支付'
    })

    // 查询条件
    const searchParams = ref({
      order_no: '',
      start_time: '',
      end_time: ''
    })

    // 列配置
    const columns = [
      {
        title: '订单号',
        dataIndex: 'order_no',
        width: '20%'
      },
      {
        title: '总价',
        dataIndex: 'total_price',
        width: '10%'
      },
      {
        title: '状态',
        dataIndex: 'state',
        width: '10%'
      },
      {
        title: '操作',
        dataIndex: 'action',
        width: '10%'
      }
    ]

    // 获取订单列表
    const fetchOrderList = async () => {
      try {
        const params = {
          ...searchParams.value,
          index: pagination.value.current,
          size: pagination.value.pageSize,
          start_time: searchParams.value.start_time ? searchParams.value.start_time : '',
          end_time: searchParams.value.end_time ? searchParams.value.end_time : '',
        }
        const res = await request.get('/order/page?' + new URLSearchParams(params))
        if (res.code !== 'success') {
          message.error(res.msg || '获取订单列表失败')
        }
        dataSource.value = res.data.rows
        pagination.value.total = res.data.count
      } catch (error) {
        message.error('获取订单列表失败')
      }
    }

    // 处理分页和排序变化
    const handleTableChange = (pag) => {
      pagination.value = pag
      fetchOrderList()
    }

    // 处理查询
    const handleSearch = () => {
      pagination.value.current = 1
      fetchOrderList()
    }

    // 处理查看
    const handleView = (record) => {
      router.push(`/user/order/detail?id=${record.id}`)
    }

    // 初始化
    onMounted(() => {
      fetchOrderList()
    })

    return {
      searchParams,
      columns,
      pagination,
      dataSource,
      handleSearch,
      handleTableChange,
      handleView,
      stateTitle
    };
  }
});
</script>
